var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-task-custom-delivery-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var contact = ref.contact;
    var step = ref.step;
    var task = ref.task;
    var deliverable = ref.deliverable;
    var errorMessage = ref.errorMessage;
    var isLoading = ref.isLoading;
    var deliverStoryUrl = ref.deliverStoryUrl;
    var deliverInsightsUrl = ref.deliverInsightsUrl;
    var isDeliverableComplete = ref.isDeliverableComplete;
    var handleInsightsFileChange = ref.handleInsightsFileChange;
    var handleStoryFileChange = ref.handleStoryFileChange;
    var deliverableHasInsights = ref.deliverableHasInsights;
    var handleStartConnection = ref.handleStartConnection;
    var handleError = ref.handleError;
return [_c('activation-custom-task-delivery-view',{attrs:{"brief":brief,"contact":contact,"step":step,"task":task,"deliverable":deliverable,"is-loading":isLoading,"error-message":errorMessage,"deliver-story-url":deliverStoryUrl,"deliver-insights-url":deliverInsightsUrl,"is-deliverable-complete":isDeliverableComplete,"deliverable-has-insights":deliverableHasInsights},on:{"story-file-change":handleStoryFileChange,"insights-file-change":handleInsightsFileChange,"start-connection":handleStartConnection,"error":handleError}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }